/**
 * DeleteFileDialog
 *
 * Thin wrapper around the shared MUI `ConfirmDialog` composite used to
 * confirm deletion of a single customer attachment. The
 * onConfirm/onCancel/onOpenChange contract is preserved exactly so the
 * parent panel wires up unchanged.
 */

import { ConfirmDialog } from "@/components/ui/confirm-dialog"
import type { FileItem } from "../file-manager-panel"

interface DeleteFileDialogProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  file: FileItem | null
  onConfirm: () => void
  onCancel: () => void
}

export function DeleteFileDialog({
  isOpen,
  onOpenChange,
  file,
  onConfirm,
  onCancel,
}: DeleteFileDialogProps) {
  return (
    <ConfirmDialog
      isOpen={isOpen}
      onClose={() => {
        onCancel()
        onOpenChange(false)
      }}
      title="Delete File"
      description={`Are you sure you want to delete "${file?.name}"? This action cannot be undone.`}
      variant="destructive"
      confirmLabel="Delete"
      onConfirm={onConfirm}
    />
  )
}
